import { render, staticRenderFns } from "./FerryPickupList.vue?vue&type=template&id=de4f1192"
import script from "@/controllers/custom/ferry_pickup/ferry-pickup-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/ferry_pickup/ferry-pickup-list.js?vue&type=script&lang=js&external"
import style0 from "./FerryPickupList.vue?vue&type=style&index=0&id=de4f1192&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports